<div class="calendar" [class.readonly]="readonly">
  <div class="calendar__header">
    @if (returnDate) {
      <div class="d-flex align-items-center">
        <h6>{{ 'dental.order.return_date.label' | translate }}:</h6>
        <span>{{ returnDate | date: 'dd-MM-yyyy' }}</span>
      </div>
    }

    <div class="arrows">
      <i class="fas fa-chevron-left" (click)="selectMonth.emit(calendarNavigation.previous)"></i>
      <p (click)="selectMonth.emit(calendarNavigation.today)">{{ 'calendar-locale.today' | translate }}</p>
      <i class="fas fa-chevron-right" (click)="selectMonth.emit(calendarNavigation.next)"></i>
    </div>
  </div>

  <div class="calendar__body">
    <div class="calendar__body__week">
      <div class="date-item"></div>

      @for (week of daysOfWeek; track week) {
        <div class="date-item">{{ week }}</div>
      }
    </div>

    <div class="calendar__body__months">
      <div class="date-item"></div>

      <div class="calendar__body__months__day">
        @for (day of daysOfMonths; track day; let index = $index; let first = $first) {
          <div
            [ngClass]="{
              'date-item': true,
              current: day?.date.toString() === currentDate.toString(),
              available: day?.available,
              active: day?.date.toString() === returnDate.toString(),
              'greyed-out': day?.isWithin2Weeks,
            }"
            [ngStyle]="{ 'margin-top': day?.weekNumber === 0 ? '3rem' : '0' }"
            (click)="chooseDay(day)">
            @if (first || day?.day === 1) {
              <p class="month-name">
                {{ day?.date | date: 'MMM' }}
              </p>
            }
            <span>{{ day?.day }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
